<template>
  <div>
    <el-dialog
      :title="detailTitle"
      :visible.sync="dialogInfo.flag"
      :close-on-click-modal="false"
      destroy-on-close
      @close="close"
      width="560px"
    >
      <div class="block" v-loading="loading">
        <el-timeline  v-if="activities && activities.length > 0">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="
              activity.auditDate == null
                ? ''
                : activity.auditDate + '\u3000' + activity.auditContent
            "
          >
            {{ activity.auditUserName }}
          </el-timeline-item>
        </el-timeline>
        <div v-else class="text-center">暂无审核详情</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { auditHistoryList } from "@/api/moveAudit";

export default {
  data() {
    return {
      activities: [],
      detailTitle: "审核详情",
      loading: false,
    };
  },
  props: {
    dialogInfo: {
      type: Object,
      default: function() {
        return {
          flag: false,
          uuid: ''
        };
      }
    }
  },
  methods: {
    // 获取审核列表
    getAuditHistoryList() {
      this.loading = true
      auditHistoryList(this.dialogInfo.uuid).then(res => {
        this.loading = false;
        if (res.code === 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (let i = 0; i < dataArray.length; i++) {
              if (
                i !== dataArray.length - 1 ||
                (i === dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
            this.uuid = this.activities[this.activities.length - 1].uuid;
          }
        }
      }).catch(_ => {
        this.loading = false;
        
      });
    },
    // 关闭
    close() {
      this.activities = [];
      this.$emit('close')
    }
  },
  created() {
    if (this.dialogInfo.uuid) {
      this.getAuditHistoryList();
    }
  },
  beforeDestroy() {
    // Bus.$off("details");
  }
};
</script>
